import { render, staticRenderFns } from "./importCert.vue?vue&type=template&id=30fb9135&scoped=true&"
import script from "./importCert.vue?vue&type=script&lang=js&"
export * from "./importCert.vue?vue&type=script&lang=js&"
import style0 from "./importCert.vue?vue&type=style&index=0&id=30fb9135&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fb9135",
  null
  
)

export default component.exports